import React from 'react';
import PlannerFrame from './PlannerFrame';

const BatteryTruckPlanner = () => {
  return (
    <PlannerFrame
      title="Battery Electric Truck Charging/Swapping Infrastructure Planning"
      src="/battery-truck-charging-planner.html"
    />
  );
};

export default BatteryTruckPlanner;
